import { Spinner } from "@components/Spinner";
import { Stack } from "@components/Stack";

export const RouteHydrateFallback = () => (
	<Stack align="center" justify="center" wide className="min-h-screen bg-ground">
		<Spinner className="size-8" />
	</Stack>
);
